import { detectGenre, generatePattern, parseSessionKey } from '@/audio/knockEngine';
import { soundSettings } from '@/audio/knockRender';

const feelLabel = (feel) => `${feel.charAt(0).toUpperCase()}${feel.slice(1)}`;

export function resolveKnockContext(tracks, keySignature) {
  const melodyClip = (tracks || []).find((track) => track.instrument === 'melody')?.clips?.[0];
  const parsedKey = parseSessionKey(melodyClip?.key || keySignature || 'C min');
  const genre = detectGenre((tracks || []).flatMap((track) => (track.clips || []).flatMap((clip) => clip.style_tags || []))) || 'default';
  return { root: parsedKey.root, scaleType: parsedKey.scaleType, genre };
}

export function regenerateKnockClip(clip, context, feel = clip.knockFeel || 'basic', seed = Math.floor(Math.random() * 0xFFFFFFFF) || 1) {
  const settings = soundSettings(clip.knockSoundType || 'Sub Sine');
  return {
    ...clip,
    name: `Knock Bass (${feelLabel(feel)})`,
    knockPattern: generatePattern(context.root, context.scaleType, feel, context.genre, seed, []),
    knockOscType: settings.oscType,
    knockFilterFreq: settings.filterFreq,
    knockDetune: settings.detune,
    knockVolume: clip.knockVolume ?? 0.8,
    knockFeel: feel,
    knockSoundType: clip.knockSoundType || 'Sub Sine',
    knockKey: `${context.root} ${context.scaleType}`,
    knockGenre: context.genre,
  };
}

/** A sound change intentionally keeps notes exactly as they are. */
export function changeKnockSound(clip, soundType) {
  const settings = soundSettings(soundType);
  return { ...clip, knockSoundType: soundType, knockOscType: settings.oscType, knockFilterFreq: settings.filterFreq, knockDetune: settings.detune };
}

export function knockTrackName(clip) {
  return `Knock Bass (${feelLabel(clip.knockFeel || 'basic')} • ${clip.knockSoundType || 'Sub Sine'})`;
}
